(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upsell-product"] && !Shopify.designMode) return;
  try {
    function initCartUpsell(section) {
  // Guard clause: avoid initializing multiple times on the same element
  if (section.dataset.initialized === 'true') return;
  section.dataset.initialized = 'true';

  const slider = section.querySelector('.cart-upsell__slider');
  if (!slider) return;

  const track = slider.querySelector('.cart-upsell__track');
  const slides = [...track.querySelectorAll('.cart-upsell__slide')];
  if (slides.length === 0) return;

  const prevBtn = slider.querySelector('.cart-upsell__prev');
  const nextBtn = slider.querySelector('.cart-upsell__next');
  const dotsWrap = slider.querySelector('.cart-upsell__dots');
  let current = 0;
  let autoplay;

  if (dotsWrap) {
    dotsWrap.innerHTML = '';
    slides.forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'cart-upsell__dot';
      if (index === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        current = index;
        updateSlider();
        restartAutoplay();
      });
      dotsWrap.appendChild(dot);
    });
  }

  function updateSlider() {
    track.style.transform = `translateX(-${current * 100}%)`;
    if (dotsWrap) {
      dotsWrap.querySelectorAll('.cart-upsell__dot').forEach((dot, index) => {
        dot.classList.toggle('active', index === current);
      });
    }
  }

  function nextSlide() {
    current++;
    if (current >= slides.length) current = 0;
    updateSlider();
  }

  function prevSlide() {
    current--;
    if (current < 0) current = slides.length - 1;
    updateSlider();
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextSlide();
      restartAutoplay();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      prevSlide();
      restartAutoplay();
    });
  }

  function startAutoplay() {
    if (slider.dataset.autoplay !== 'true') return;
    autoplay = setInterval(() => {
      nextSlide();
    }, Number(slider.dataset.speed) || 3000);
  }

  function restartAutoplay() {
    clearInterval(autoplay);
    startAutoplay();
  }

  startAutoplay();

  // Add to cart click event listener
  section.querySelectorAll('.cart-upsell__add').forEach(button => {
    button.addEventListener('click', () => {
      const variantId = button.dataset.variantId;
      button.classList.add('loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(() => {
        button.classList.remove('loading');
        const drawer = document.querySelector('cart-drawer');

        if (drawer && typeof drawer.renderContents === 'function') {
        const sections = drawer.getSectionsToRender();
          fetch(`/?sections=${sections.map(section => section.id).join(',')}`)
          .then(response => response.json())
          .then(data => {
            drawer.renderContents({
              sections: data
            });
          });
          
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(() => {
        button.classList.remove('loading');
      });
    });
  });
}

function initAllUpsells() {
  document.querySelectorAll('.cart-upsell').forEach(initCartUpsell);
}

// Initial Run
document.addEventListener('DOMContentLoaded', () => {
  initAllUpsells();

  // Watch for dynamic cart drawer changes (DOM mutations)
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      initAllUpsells();
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }
});

// Re-initialize when themes dispatch standard cart update events
document.addEventListener('cart:updated', initAllUpsells);
document.addEventListener('cart:refresh', initAllUpsells);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-modal"] && !Shopify.designMode) return;
  try {
    /*

window.initProductMediaModal = function () {

  document.querySelectorAll('.product-media-modal').forEach((modal) => {

    const images = [...modal.querySelectorAll('.product-media-modal__slider img')];
    const prev = modal.querySelector('.product-media-modal__prev');
    const next = modal.querySelector('.product-media-modal__next');

    if (!images.length) return;

    let current = images.findIndex(img => img.classList.contains('active'));
    if (current < 0) current = 0;

    function show(index) {

      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;

      images.forEach((img, i) => {
        img.style.display = i === index ? 'block' : 'none';
        img.classList.toggle('active', i === index);
      });

      current = index;
    }

    show(current);

    next.onclick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      show(current + 1);
    };

    prev.onclick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      show(current - 1);
    };

  });

};

document.addEventListener('DOMContentLoaded', window.initProductMediaModal);
*/

window.initProductMediaModal = function () {
  document.querySelectorAll('.product-media-modal').forEach((modal) => {
    const slider = modal.querySelector('.product-media-modal__slider');
    const prev = modal.querySelector('.product-media-modal__prev');
    const next = modal.querySelector('.product-media-modal__next');

    // 1. Add 'active' class to slider and navigation buttons 
    //    so '.product-media-modal__content > *:not(.active)' doesn't hide them
    if (slider) slider.classList.add('active');
    if (prev) prev.classList.add('active');
    if (next) next.classList.add('active');

    if (!slider) return;

    // 2. Target all direct children inside the slider
    const items = [...slider.children];
    if (!items.length) return;

    let current = items.findIndex((item) => item.classList.contains('active'));
    if (current < 0) current = 0;

    function show(index) {
      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;

      items.forEach((item, i) => {
        if (i === index) {
          item.classList.add('active');
          item.style.setProperty('display', 'block', 'important');
        } else {
          item.classList.remove('active');
          item.style.setProperty('display', 'none', 'important');
        }
      });

      current = index;
    }

    show(current);

    if (next) {
      next.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(current + 1);
      };
    }

    if (prev) {
      prev.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(current - 1);
      };
    }
  });
};

document.addEventListener('DOMContentLoaded', window.initProductMediaModal);

// 3. Re-initialize on mobile tap when opening the modal
document.addEventListener('click', (e) => {
  if (e.target.closest('.product__media-item, [data-media-id]')) {
    setTimeout(window.initProductMediaModal, 50);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping_bar"] && !Shopify.designMode) return;
  try {
    (function () {
        function formatMoney(cents) {
            return (cents / 100).toLocaleString(
            Shopify.locale || 'en',
            {
                style: 'currency',
                currency: Shopify.currency.active || Shopify.currency.currency || 'USD'
            } );
        }
        window.updateShippingBar = function () {
            const shippingBar = document.querySelector('#ShippingBar');
            if (!shippingBar) return;
            fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                const freeShipping = Number(shippingBar.dataset.freeShipping) * 100;
                const text = shippingBar.querySelector('.shipping-progress__text');
                const fill = shippingBar.querySelector('.shipping-progress__fill');
                const beforeText = text.dataset.before;
                const afterText = text.dataset.after;
                const remaining = Math.max(freeShipping - cart.total_price, 0);
                let progress = (cart.total_price / freeShipping) * 100;
                if (progress > 100) progress = 100;
                if (progress < 0) progress = 0;
                fill.style.width = progress + "%";
                if (remaining > 0) {
                    text.innerHTML =
                        beforeText +
                        ' <strong>' +
                        formatMoney(remaining) +
                        '</strong> away from free shipping';
                } else {
                    text.innerHTML = afterText;
                }
            });
        };
        document.addEventListener("DOMContentLoaded", function () {
            updateShippingBar();
        });
    })();
  } catch(e) { console.error(e); }
})();

})();
